// Central registry of every localStorage key prefix that is deliberately scoped per clinic
// account (see clearAccountScopedLocalStorage.ts) so it survives a sign-out on a shared
// workstation. Each storage helper imports its own prefix from here rather than defining it
// locally — keeping every prefix in one file makes an accidental collision with an existing
// one visible at write time: before adding a new account-scoped key, look at the list below.
export const WORKING_HOURS_START_KEY_PREFIX = "calendar-working-hours-start-";
export const WORKING_HOURS_END_KEY_PREFIX = "calendar-working-hours-end-";
export const COLUMN_WIDTH_KEY_PREFIX = "calendar-column-width-";
export const DOCTOR_FILTER_KEY_PREFIX = "happydoc_dashboard_doctor_filter_v1:";
export const SELECTED_CLINIC_KEY_PREFIX = "happydoc_selected_clinic_v1:";
export const SHEPHERD_EMAIL_KEY_PREFIX = "happydoc_shepherd_email_v1:";
export const MOBILE_BROWSER_RECORDING_ACK_KEY_PREFIX = "happydoc_mobile_browser_recording_ack_v1:";
export const MIC_CHOICE_KEY_PREFIX = "happydoc_mic_choice_v1";
